import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"text-align":"right","margin-bottom":"20px"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("否")

import { ref, reactive, onMounted, unref } from 'vue';
import { GbDialog } from '@/components/GbDialog/Index';
import { GbTables } from '@/components/GbTables';
import { useGbTable } from '@/hooks/useGbTable';
import { useLocales } from '../../../../hooks/useLocales';
import { useDictionary } from '@/store/dictionary.store';
import { GetStampListApi, StampDeleteApi } from '@/apis/basics/stamps.api';
import { TableColumn } from '@/components/GbTables/GbTablesTypes';
import StampDialog from './StampDialog.vue';
import moment from 'moment';


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const { getName } = useDictionary();

const dialogRef = ref<ComponentRef<typeof StampDialog>>();

/* GbTable 配置 */
const { register, tableObject, methods } = useGbTable<any>({
	getListApi: GetStampListApi,
	delListApi: StampDeleteApi,
	response: { data: 'data', total: 'total' },
});

const { t } = useLocales();
const { setSearchParams } = methods;

const searchDto = reactive<any>({
	page_size: 10,
	current: 1,
	mainstay_id: '',
});

/* 数据Table绑定设置 */
const tabColumns = reactive<TableColumn[]>([
	{ field: 'stamp_no', label: '印章编号', columnWidth: '120' },
	{ field: 'stamp_name', label: '印章名称', columnWidth: '120' },
	{ field: 'stamp_type', label: '印章类型', columnWidth: '80', align: 'center' },
	{ field: 'remark', label: '备注' },
	{ field: 'managers_name', label: '管章人', columnWidth: '80', align: 'center' },
	{ field: 'is_define', label: '默认', columnWidth: '60', align: 'center' },
	{ field: 'is_enabled', label: '状态', columnWidth: '80', align: 'center' },
	{ field: 'created_time', label: '创建日期', columnWidth: '120', fixed: 'right' },
	{ field: 'action', width: '120px', label: '操作', fixed: 'right', align: 'center' },
]);

const showStamp = ref<boolean>(false);

const actions = {
	/* 创建 */
	creaetActions: () => {
		unref(dialogRef)?.create(searchDto.mainstay_id);
	},

	/* 编辑 */
	editActions: (rowId: string) => {
		unref(dialogRef)?.modify(rowId);
	},

	/* 删除记录 */
	deleteActions: (row: any) => {
		const delData = { id: row.id, revision: row.revision };
		methods.deleteRows(delData);
	},

	/* 刷新数据 */
	refreshList: () => {
		setSearchParams(searchDto);
	},
};

/* 打开对话框 */
const showDialog = (mainstayId: string) => {
	searchDto.mainstay_id = mainstayId;

	actions.refreshList();

	showStamp.value = true;
};

expose({ showDialog });

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_ElButton = _resolveComponent("ElButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(GbDialog), {
      title: "印章管理",
      modelValue: showStamp.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showStamp).value = $event)),
      style: {"width":"1024px"}
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          size: "small",
          type: "info",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (showStamp.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('buttons.closed')), 1)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_button, {
            size: "small",
            type: "primary",
            onClick: actions.creaetActions
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('buttons.insert')) + "印章 ", 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createVNode(_unref(GbTables), {
          pageSize: _unref(tableObject).pageSize,
          "onUpdate:pageSize": _cache[0] || (_cache[0] = ($event: any) => ((_unref(tableObject).pageSize) = $event)),
          currentPage: _unref(tableObject).currentPage,
          "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((_unref(tableObject).currentPage) = $event)),
          columns: _unref(tabColumns),
          data: _unref(tableObject).tableList,
          loading: _unref(tableObject).loading,
          pagination: { total: _unref(tableObject).total },
          onRegister: _unref(register)
        }, {
          is_enabled: _withCtx(({ row }) => [
            (row.is_enabled == 'Y')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "success"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('status.enabled')), 1)
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_el_tag, {
                  key: 1,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('status.diabled')), 1)
                  ]),
                  _: 1
                }))
          ]),
          is_define: _withCtx(({ row }) => [
            (row.is_define == 'Y')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "success"
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_el_tag, {
                  key: 1,
                  type: "waning"
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }))
          ]),
          stamp_type: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(getName)('stamp_type', row.stamp_type)), 1)
          ]),
          created_time: _withCtx(({ row }) => [
            _createElementVNode("span", null, _toDisplayString(_unref(moment)(row.created_time).format('YYYY-MM-DD HH:mm')), 1)
          ]),
          action: _withCtx(({ row }) => [
            _createVNode(_component_ElButton, {
              type: "success",
              link: "",
              onClick: ($event: any) => (actions.editActions(row.id))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('buttons.modify')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_ElButton, {
              type: "danger",
              link: "",
              onClick: ($event: any) => (actions.deleteActions(row))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('buttons.delete')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }, 8, ["pageSize", "currentPage", "columns", "data", "loading", "pagination", "onRegister"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(StampDialog, {
      ref_key: "dialogRef",
      ref: dialogRef,
      onRefresh: actions.refreshList
    }, null, 8, ["onRefresh"])
  ], 64))
}
}

})